import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mcommerce-dashboard',
  templateUrl: './mcommerce-dashboard.component.html',
  styleUrls: ['./mcommerce-dashboard.component.scss']
})
export class McommerceDashboardComponent implements OnInit {

  currenttrip = 25;
  virtualcashregister = 3;
  auditconfig = 11;

  constructor() { }

  ngOnInit() {
  }

}
